module.exports = __webpack_public_path__ + "img/tech18.4ac68dfe.png";